import { NotFoundEntity } from 'interfaces/entity'
import { ENTITY_STATUS_NOT_FOUND } from 'constants/entity'

export function createNotFoundEntity (id: NotFoundEntity['id']): NotFoundEntity {
  return {
    id,
    _status: ENTITY_STATUS_NOT_FOUND,
  }
}

export function isEntityNotFound<TEntity extends { id: any }> (entity: TEntity | NotFoundEntity): entity is NotFoundEntity {
  const { _status } = entity as NotFoundEntity
  return _status === ENTITY_STATUS_NOT_FOUND
}
